import { Color } from '@/types'
import { Badge as BaseBadge, BadgeProps as BaseBadgeProps } from '../base/badge'

type BadgeColor = BaseBadgeProps['color']

type MaintenanceType = {
  name: string
  color: BadgeColor | Color
}

interface BadgeProps {
  maintenanceType: MaintenanceType
}

export const Badge = ({ maintenanceType }: BadgeProps) => {
  const { color, name } = maintenanceType

  return <BaseBadge color={color?.toLowerCase() as BadgeColor}>{ name }</BaseBadge>
}
